import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const Vakansii = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        toggleItem(event) {
            if (event.target && event.target.tagName !== 'A') {

                let block = $(event.target);

                if (!block.hasClass('js-career-item'))
                    block = block.closest('.js-career-item');

                if (!block.hasClass('is-open')) {
                    block.addClass('is-open');
                    block.find('.js-career-item-btn').addClass('is-open');
                    block.find('.js-career-item-btn').removeClass('is-close');
                    block.find('.js-career-item-dropdown').slideDown();
                } else {
                    block.find('.js-career-item-dropdown').slideUp(400, function () {
                        block.removeClass('is-open');
                        block.find('.js-career-item-btn').removeClass('is-open');
                        block.find('.js-career-item-btn').addClass('is-close');
                    });
                }
            }
        },
        clearPhone(phone) {
            phone = phone.replace(/[^0-9+]/g, '');
            return 'tel:' + phone;
        }
    },
    updated() {

    },
    mounted() {

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS && this.struct[this.structKey].componentData.ITEMS.length" class="section">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
                    Действующие вакансии
                </h2>
            </div>
        </div>
        <div class="career__list">

            <div class="career__list-item js-career-item" @click="toggleItem($event)" v-for="item in this.struct[this.structKey].componentData.ITEMS" :key="item.ID">
                <div class="career__list-item-heading">
                    {{item.NAME}}
                    <div class="career__list-item-btn js-career-item-btn" @click="toggleItem($event)">
                        <svg class="icon icon-arrow-down">
                            <use xlink:href="#icon-arrow-down"></use>
                        </svg>
                    </div>
                </div>
                <div class="career__list-item-dropdown js-career-item-dropdown">
                    <div class="career__list-item-dropdown-wp">
                        <div v-if="item.WORK" class="career__list-item-dropdown-block">
                            <div class="career__list-item-dropdown-title">
                                Обязанности
                            </div>
                            <div class="career__list-item-dropdown-text content" v-html="item.WORK">
                            </div>
                        </div>
                        <div v-if="item.REQ" class="career__list-item-dropdown-block">
                            <div class="career__list-item-dropdown-title">
                                Требования
                            </div>
                            <div class="career__list-item-dropdown-text content" v-html="item.REQ">
                            </div>
                        </div>
                        <div class="career__list-item-dropdown-block">
                            <div class="career__list-item-dropdown-title" v-if="item.TERM">
                                Условия
                            </div>
                            <div v-if="item.TERM" class="career__list-item-dropdown-text content" v-html="item.TERM">
                            </div>
                            <div v-if="item.PHONE || item.EMAIL" class="career__list-item-dropdown-contacts">

                                <a v-if="item.PHONE" :href="clearPhone(item.PHONE)">
                                    <svg class="ico ico-map-tel" width="21" height="20" aria-hidden="true"><use xlink:href="#ico-map-tel"></use></svg>
                                    {{item.PHONE}}
                                </a>

                                <a v-if="item.EMAIL" :href="'mailto:' + item.EMAIL">
                                    <svg class="ico ico-map-mail" width="21" height="20" aria-hidden="true"><use xlink:href="#ico-map-mail"></use></svg>
                                    {{item.EMAIL}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="career__list-item-btn js-career-item-btn">
                    <svg class="icon icon-arrow-down">
                        <use xlink:href="#icon-arrow-down"></use>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</section>
    `
}